import type { ConnectionStatus } from '../state/gameContext';

const STATUS_CONFIG: Record<
  ConnectionStatus,
  { label: string; dotClass: string; textClass: string }
> = {
  connected: {
    label: 'Connected',
    dotClass: 'bg-secondary animate-pulse',
    textClass: 'text-secondary',
  },
  connecting: {
    label: 'Connecting…',
    dotClass: 'bg-tertiary animate-pulse',
    textClass: 'text-tertiary',
  },
  reconnecting: {
    label: 'Reconnecting…',
    dotClass: 'bg-tertiary animate-pulse',
    textClass: 'text-tertiary',
  },
  disconnected: {
    label: 'Disconnected',
    dotClass: 'bg-error',
    textClass: 'text-error',
  },
};

interface ConnectionStatusBadgeProps {
  status: ConnectionStatus;
  className?: string;
}

export function ConnectionStatusBadge({ status, className = '' }: ConnectionStatusBadgeProps) {
  const cfg = STATUS_CONFIG[status];
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-surface-container-high/80 border border-white/10 text-label-sm ${className}`}
      aria-live="polite"
      data-testid="connection-status"
      data-status={status}
    >
      <span className={`w-2 h-2 rounded-full ${cfg.dotClass}`} aria-hidden />
      <span className={`font-label-bold ${cfg.textClass}`}>{cfg.label}</span>
    </div>
  );
}
